import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.80352 9.5L9 2.30352L16.1965 9.5L9 16.6965L1.80352 9.5ZM9.99492 0.911328C9.44648 0.362891 8.55703 0.362891 8.00508 0.911328L0.411328 8.50508C-0.137109 9.05352 -0.137109 9.94297 0.411328 10.4949L8.00508 18.0887C8.55352 18.6371 9.44297 18.6371 9.99492 18.0887L17.5887 10.4949C18.1371 9.94648 18.1371 9.05703 17.5887 8.50508L9.99492 0.911328ZM9 5C8.53242 5 8.15625 5.37617 8.15625 5.84375V9.78125C8.15625 10.2488 8.53242 10.625 9 10.625C9.46758 10.625 9.84375 10.2488 9.84375 9.78125V5.84375C9.84375 5.37617 9.46758 5 9 5ZM10.125 12.875C10.125 12.5766 10.0065 12.2905 9.7955 12.0795C9.58452 11.8685 9.29837 11.75 9 11.75C8.70163 11.75 8.41548 11.8685 8.2045 12.0795C7.99353 12.2905 7.875 12.5766 7.875 12.875C7.875 13.1734 7.99353 13.4595 8.2045 13.6705C8.41548 13.8815 8.70163 14 9 14C9.29837 14 9.58452 13.8815 9.7955 13.6705C10.0065 13.4595 10.125 13.1734 10.125 12.875Z",
		fill: "currentColor"
	})
});
export default SvgWarning;
